import React, { Component } from 'react';
import { connect } from 'react-redux';
//import ReactEcharts from 'echarts-for-react';
import 'react-step-progress-bar/styles.css';
import {
  ProgressBar,
  Step
} from 'react-step-progress-bar';
import {
  saveScore
} from '../../actions/client';
import {
  BS_TEST,
} from '../../constants.js';
import TestResult from './TestResult';
import s from './BehavioralStress.css';
import cs from './common.css';


class BehavioralStress extends Component {

  constructor() {
    super();
    this.state = {
      qNum: 0,
      questions: [1, 2, 3, 4],
      answers: ['', '', '', 0,'', '', '', 0],
      maintain1: '',
      maintain2: '',
      maintain3: '',
      maintainScore: 0,
      reduce1: '',
      reduce2: '',
      reduce3: '',
      reduceScore: 0,
    };
  }

  componentDidMount() {
    const panes = this.generateQuestions();
    this.setState(Object.assign({}, this.state, {
      panes: panes,
    }));
    this.getNextQuestion();
  }

  editFormChange = (event) => {
    const target = event.target;
    const {
      name,
      value,
     } = target;
    const newState = Object.assign({}, this.state);
    newState[name] = value;
    this.setState(Object.assign({}, this.state, newState));
  }

  getNextQuestion(e) {
    let qNum = 5;
    // copy questions
    const questions = [].concat(this.state.questions);
    // if more questions get and remove one randomly
    if (questions.length > 0) {
      qNum = questions.shift();
    }
    // update the state with current num and remaining questions
    if (qNum === 5) {
      this.props.saveScore(BS_TEST, this.state.answers);
    }
    this.setState(Object.assign({}, this.state, {
      qNum: qNum,
      questions: questions,
    }));
  }

  answerQuestion = (e) => {
    e.preventDefault();
    const answers = [].concat(this.state.answers);
    // set answer, get next question
    const qNum = this.state.qNum;
    if(qNum === 1) {
      answers[0] = this.state.maintain1;
      answers[1] = this.state.maintain2;
      answers[2] = this.state.maintain3;
    } else if(qNum === 2) {
      answers[3] = parseInt(this.state.maintainScore);
    } else if(qNum === 3) {
      answers[4] = this.state.reduce1;
      answers[5] = this.state.reduce2;
      answers[6] = this.state.reduce3;
    } else if (qNum === 4) {
      answers[7] = parseInt(this.state.reduceScore);
    }
    this.setState(Object.assign({}, this.state, {
      answers: answers,
    }), () => {
      this.getNextQuestion();
    });
  }

  render() {
    const {
      qNum,
      questions,
      panes,
    } = this.state;
  
    if (qNum === 5) {
      return (
        <TestResult />
      );
    } else {
      let scrollBase = 1140;
      if (window.matchMedia('(max-device-width: 1200px)').matches) {
        scrollBase = 940;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: landscape)').matches) {
        scrollBase = 710;
      }
      if (window.matchMedia('(max-device-width: 992px) and (orientation: portrait)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('((max-device-width : 414px)').matches) {
        scrollBase = 384;
      }
      if (window.matchMedia('(max-device-width : 375px)').matches) {
        scrollBase = 345;
      }
      if (window.matchMedia('(min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 738;
      }
      if (window.matchMedia('(min-device-width : 1024px) and (max-device-width : 1366px) and (-webkit-min-device-pixel-ratio: 2)').matches) {
        scrollBase = 994;
      }
      const ctrans = `translate(${-(((qNum - 1) * 30) + ((qNum - 1) * scrollBase))}px)`;
      return (
        <div>
          <div className="row">
            <div className="col-md-12">
              <div className={cs.headerRow}>
                <ProgressBar
                  unfilledBackground="#BDC2C6"
                  filledBackground="#35ccd2"
                  height='1px'
                  percent={100 / 3 * (3 - questions.length)}
                >
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                  <Step transition="scale">
                    {({ accomplished }) => (<div className={accomplished ? s.stepOn : s.stepOff} />)}
                  </Step>
                </ProgressBar>
              </div>
              <div className={cs.headerTitle}>Behavioral Lifestyle Assessment: What lifestyle will make you satisfied in retirement?</div>
            </div>
          </div>
          <div className="row">
            <div className={'col-md-12'} style={{ overflow: 'hidden',paddingTop:'30px',paddingBottom:'30px'}}>
              <div className={cs.insidepane} style={{ transform: ctrans }}>
                {panes}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  generateQuestions() {
    let  buttonVisibility =  <button className={s.showButton} >Submit</button>

    return (
      <div>
        {/* <BehavioralStressQuestion /> */}
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
            Imagine you are retiring and plan to maintain 70 percent of your pre-retirement spending.<br />
            Please write down three expenditures you will maintain during retirement, such as utilities.
          </div>
          <div>
            <form  onSubmit={this.answerQuestion} >
              <div className={s.addExpenseForm + ' row'}>
                <div className="col-md-10">
                  <div className={'form-group'}>
                      <input
                        id="maintainExpense1"
                        name="maintain1"
                        onChange={this.editFormChange}
                        type="text" className={s.formFieldText + ' form-control'}
                        placeholder="Expenditure 1"
                      />
                  </div>
                  <div className={'form-group'}>
                      <input
                        id="maintainExpense2"
                        name="maintain2"
                        onChange={this.editFormChange}
                        type="text"
                        className={s.formFieldText + ' form-control'}
                        placeholder="Expenditure 2"
                      />
                  </div>
                  <div className={'form-group'}>
                      <input
                        id="maintainExpense3"
                        name="maintain3"
                        onChange={this.editFormChange}
                        type="text"
                        className={s.formFieldText + ' form-control'}
                        placeholder="Expenditure 3"
                      />
                  </div>
                  <div className={'form-group row'}>
                      {buttonVisibility}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
            How satisfying does this spending plan seem on a 7-point scale, <br />
            with 1 being "not satisfying at all" and 7 being "totally satisfying"?
          </div>
          <div>
            <form onSubmit={this.answerQuestion}>
              <div className="row">
                <div className="col-md-12" style={{ textAlign: 'center' }}>
                  <button name='maintainScore' id='maintainExpenseScore' value="1" onClick={this.editFormChange} className={s.radioButton}>1</button>
                  <button name='maintainScore' id='maintainExpenseScore' value="2" onClick={this.editFormChange} className={s.radioButton}>2</button>
                  <button name='maintainScore' id='maintainExpenseScore' value="3" onClick={this.editFormChange} className={s.radioButton}>3</button>
                  <button name='maintainScore' id='maintainExpenseScore' value="4" onClick={this.editFormChange} className={s.radioButton}>4</button>
                  <button name='maintainScore' id='maintainExpenseScore' value="5" onClick={this.editFormChange} className={s.radioButton}>5</button>
                  <button name='maintainScore' id='maintainExpenseScore' value="6" onClick={this.editFormChange} className={s.radioButton}>6</button>
                  <button name='maintainScore' id='maintainExpenseScore' value="7" onClick={this.editFormChange} className={s.radioButton}>7</button>
                </div>
              </div>
            </form>
          </div>
          <div>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
            Imagine you are retiring and plan to cut 30 percent of your pre-retirement spending.<br />
            Please write down three expenditures you will reduce or cut during retirement, such as travel.
          </div>
          <div>
            <form onSubmit={this.answerQuestion}>
              <div className={s.addExpenseForm + ' row'}>
                <div className="col-md-10">
                  <div className={'form-group'}>
                      <input
                        id="reduceExpense1"
                        name="reduce1"
                        onChange={this.editFormChange}
                        type="text" className={s.formFieldText + ' form-control'}
                        placeholder="Expenditure 1"
                      />
                    </div>
                    <div className={'form-group'}>
                      <input
                        id="reduceExpense2"
                        name="reduce2"
                        onChange={this.editFormChange}
                        type="text"
                        className={s.formFieldText + ' form-control'}
                        placeholder="Expenditure 2"
                      />
                    </div>
                    <div className={'form-group'}>
                      <input
                        id="reduceExpense3"
                        name="reduce3"
                        onChange={this.editFormChange}
                        type="text"
                        className={s.formFieldText + ' form-control'}
                        placeholder="Expenditure 3"
                      />
                    </div>
                    <div className={'form-group row'}>
                      {/* <button className={s.showButton} >Submit</button> */}
                      {buttonVisibility}
                    </div>
                  </div>
                </div>
            </form>
          </div>
        </div>
        <div className={cs.qpane + ' ' + cs.qpaneSize}>
          <div className={cs.question}>
            How satisfying does this spending plan seem on a 7-point scale,<br />
            with 1 being "not satisfying at all" and 7 being "totally satisfying"?
          </div>
          <div>
            <form onSubmit={this.answerQuestion} >
              <div className="row">
                <div className="col-md-12" style={{ textAlign: 'center' }}>
                  <button name='reduceScore' id='reduceExpenseScore' value="1" onClick={this.editFormChange} className={s.radioButton}>1</button>
                  <button name='reduceScore' id='reduceExpenseScore' value="2" onClick={this.editFormChange} className={s.radioButton}>2</button>
                  <button name='reduceScore' id='reduceExpenseScore' value="3" onClick={this.editFormChange} className={s.radioButton}>3</button>
                  <button name='reduceScore' id='reduceExpenseScore' value="4" onClick={this.editFormChange} className={s.radioButton}>4</button>
                  <button name='reduceScore' id='reduceExpenseScore' value="5" onClick={this.editFormChange} className={s.radioButton}>5</button>
                  <button name='reduceScore' id='reduceExpenseScore' value="6" onClick={this.editFormChange} className={s.radioButton}>6</button>
                  <button name='reduceScore' id='reduceExpenseScore' value="7" onClick={this.editFormChange} className={s.radioButton}>7</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );

  
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, {
  saveScore,
})(BehavioralStress);




// WEBPACK FOOTER //
// ./src/components/ClientMode/BehavioralStress.js